import { Typography } from '@components/base';
import QuotePricePackageWrapper from '../quote-price-package-wrapper';
import css from './index.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@components/common';

const QuoteDdpPrice = (props: any) => {
  const {
    ddpPrice,
    ddpPriceCurrency,
    ddpPriceWeightUnit,
    ddpPriceManualOverride,
    ddpPriceWeightUnitWatch,
    drayageCharge,
    drayageChargeCurrency,
    isfFiling,
    isfFilingCurrency,
    customClearance,
    selectedCurrency,
    selectedWeightSystemChildOptions,
    cifPriceManualOverride,
    insuranceCost,
    cfrPrice,
    basePrice,
    finalExWorksPrice,
    fobPrice,
    totalPortAndClearanceExpenses,
    totalLocalFreight,
    totalFreight,
    totalWeight,
    cifPrice,
    warehousingCostCurrency,
    warehousingCostPrice,
    additionalCost,
    additionalCostCurrency,
    switchBlCost,
    switchBLCostCurrency,
    primaryUnitWatch,
    filterState
  } = props;

  const { mtt } = filterState;
  const { setValue, control } = useFormContext();

  return (
    <>
      <div className={css.rowWrapper}>
        <QuotePricePackageWrapper
          label="Drayage and Transportation Charges"
          currencyPlaceholder="Currency"
          inputPlaceholder="Drayage and Transportation"
          input={drayageCharge}
          currency={drayageChargeCurrency}
          control={control}
          currencyOptions={selectedCurrency}
          inputOnChange={() => {
            ddpPriceManualOverride &&
              setValue(ddpPriceManualOverride, false, { shouldDirty: false });
          }}
        />
        <QuotePricePackageWrapper
          label="Custom / ISF Filing Charges"
          currencyPlaceholder="Currency"
          inputPlaceholder="Custom / ISF Filing"
          input={isfFiling}
          currency={isfFilingCurrency}
          control={control}
          currencyOptions={selectedCurrency}
          inputOnChange={() => {
            ddpPriceManualOverride &&
              setValue(ddpPriceManualOverride, false, { shouldDirty: false });
          }}
        />
      </div>
      <div className={css.rowWrapper}>
        <Controller
          name={customClearance}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label={
                <span>
                  Custom Clearance Charges on CIF
                  <Typography variant="label"> ( % )</Typography>
                </span>
              }
              onChange={(e) => {
                ddpPriceManualOverride &&
                  setValue(ddpPriceManualOverride, false, { shouldDirty: false });
                field.onChange(e);
              }}
              placeholder="Enter value in percentage"
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <QuotePricePackageWrapper
          label="Warehousing Charges"
          currencyPlaceholder="Currency"
          inputPlaceholder="Warehousing Charges"
          input={warehousingCostPrice}
          currency={warehousingCostCurrency}
          control={control}
          currencyOptions={selectedCurrency}
          inputOnChange={() => {
            ddpPriceManualOverride &&
              setValue(ddpPriceManualOverride, false, { shouldDirty: false });
          }}
        />
      </div>
      <div className={css.rowWrapper}>
        <QuotePricePackageWrapper
          label="DDP Price"
          control={control}
          input={ddpPrice}
          inputPlaceholder="DDP Price"
          inputOnChange={() => {
            setValue(ddpPriceManualOverride, true, { shouldDirty: true });
            setValue(finalExWorksPrice, 0);
            setValue(basePrice, 0);
            setValue(fobPrice, 0);
            setValue(cfrPrice, 0);
            setValue(cifPrice, 0);
            setValue(totalLocalFreight, 0);
            setValue(totalPortAndClearanceExpenses, 0);
            setValue(totalWeight, 0);
            setValue(totalFreight, 0);
            setValue(insuranceCost, 0);
          }}
          unit={ddpPriceWeightUnit}
          unitPlaceholder="Per Unit"
          unitOptions={selectedWeightSystemChildOptions}
          unitOnChange={() => {
            setValue(ddpPriceManualOverride, false, { shouldDirty: false });
          }}
          currency={ddpPriceCurrency}
          currencyOptions={selectedCurrency}
          currencyPlaceholder="Currency"
        />
        <QuotePricePackageWrapper
          label={
            <span>
              Additional Cost
              {primaryUnitWatch && (
                <Typography variant="label"> ( Per {primaryUnitWatch?.label} )</Typography>
              )}
            </span>
          }
          currencyPlaceholder="Currency"
          inputPlaceholder="Enter Price"
          input={additionalCost}
          currency={additionalCostCurrency}
          control={control}
          currencyOptions={selectedCurrency}
        />
      </div>
      <div className={css.rowWrapper}>
        {mtt && (
          <QuotePricePackageWrapper
            label="Switch BL Cost"
            currencyPlaceholder="Currency"
            inputPlaceholder="Enter Price"
            input={switchBlCost}
            currency={switchBLCostCurrency}
            control={control}
            currencyOptions={selectedCurrency}
          />
        )}
      </div>
    </>
  );
};

export default QuoteDdpPrice;
